import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  MenuDivider,
  Text,
  Flex,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { FaChevronDown } from "react-icons/fa6";
import { WrapBridgeMappings } from "@constants/common";

const MenuItemProps = {
  p: "6px 8px",
  borderRadius: "6px",
  fontSize: "14px",
  fontWeight: "400",
};

const SelectedMenuItemProps = {
  ...MenuItemProps,
  bg: "#F5F5F7",
  color: "#142528",
  fontWeight: "600",
  lineHeight: "20px",
  letterSpacing: "-0.70px",
};

export type TTokenSelect = {
  sectionLabel: string;
  options: { id: string | number; title: string }[];
  placeholder?: string;
  selectedOption?: { id?: string | number; title?: string };
  onSelection: (args: any) => void;
};
const TokenSelect = ({
  sectionLabel,
  options,
  placeholder = "",
  selectedOption,
  onSelection,
}: TTokenSelect) => {
  selectedOption =
    selectedOption?.id === undefined && placeholder
      ? { id: "placeholder", title: placeholder }
      : selectedOption?.id != undefined
      ? selectedOption
      : options[0];
  return (
    <Box w="100%" mb="12px">
      <Flex w="100%" justifyContent="space-between">
        <Text mb="12px" color="#A1B6BA" fontSize={"12px"} fontWeight={400}>
          {sectionLabel}
        </Text>
      </Flex>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<FaChevronDown />}
          w="100%"
          textAlign="left"
          className="menuButtonStake"
          p={{ base: "12px", md: "12px 10px 12px 8px" }}
          h="auto"
          borderRadius="16px"
          bg="#E4F8F8"
          color="textPrimary"
          _hover={{
            bg: "#E4F8F8",
          }}
          _active={{
            bg: "#E4F8F8",
          }}
          fontWeight="500"
          fontSize={{ base: "14px", md: "16px" }}
          letterSpacing="-0.70px"
        >
          <Flex
            alignItems="center"
            gap="8px"
            key={sectionLabel + selectedOption?.id}
          >
            {selectedOption?.id &&
              WrapBridgeMappings.ICONS[selectedOption?.id] && (
                <BaseImage
                  width={24}
                  height={24}
                  alt="lst"
                  src={WrapBridgeMappings.ICONS[selectedOption?.id]}
                />
              )}
            <Flex alignItems="center" justify="space-between" flex={1} gap={2}>
              <Box flex={1}>
                {selectedOption?.id === "placeholder"
                  ? placeholder
                  : selectedOption?.title}
              </Box>
            </Flex>
          </Flex>
        </MenuButton>
        <MenuList
          transformOrigin="top !important"
          w={{
            base: "100%",
          }}
          p="8px"
          h={options.length > 7 ? { base: "38vh", md: "45vh" } : "auto"}
          overflowY={"auto"}
          border="1px solid #AEDFCA"
          bg="backgroundCard"
          fontSize="18px"
          fontWeight="400"
          zIndex={"8"}
        >
          {options.map((option, index) => {
            if (option.id === "divider") {
              return <MenuDivider my="12px" key={index} />;
            } else {
              const props =
                option.id === options[0].id
                  ? { ...SelectedMenuItemProps }
                  : { ...MenuItemProps };
              return (
                <MenuItem
                  {...props}
                  _disabled={{
                    cursor: "not-allowed",
                    color: "textTertiary",
                  }}
                  bg={
                    selectedOption?.id === option?.id
                      ? "var(--chakra-colors-gray-100)"
                      : "backgroundCard"
                  }
                  padding={2}
                  marginBottom={1}
                  key={sectionLabel + index}
                  onClick={() => onSelection(option)}
                >
                  <Flex
                    justifyContent="space-between"
                    w="100%"
                    alignItems="center"
                  >
                    <Flex alignItems="center" gap="8px" flex={1}>
                      {option?.id && WrapBridgeMappings.ICONS[option?.id] && (
                        <BaseImage
                          width={24}
                          height={24}
                          alt="lst"
                          src={WrapBridgeMappings.ICONS[option?.id]}
                        />
                      )}
                      <Flex
                        justify="space-between"
                        flex={1}
                        alignItems="center"
                        gap={2}
                      >
                        <Box flex={1} fontSize={"18px"}>
                          {option.title}
                        </Box>
                      </Flex>
                    </Flex>
                  </Flex>
                </MenuItem>
              );
            }
          })}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default TokenSelect;
